export default __webpack_public_path__ + "static/media/Marty Stanchev.024d9c15.png";